// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  staging: false,
  envIndicator: true,
  baseAppUrl: 'https://jzjky1knze.execute-api.us-west-2.amazonaws.com/dev/',
  loginPortalUrl: 'https://crexnmsdev1.solint.net/portal',
  mngAppBaseUrl: 'https://jzjky1knze.execute-api.us-west-2.amazonaws.com/dev/',
  manageAuthUrl: 'https://crexappstore-dev.us.auth0.com/v2/'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
